/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Auth_Desc4Inputs */

const en_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login, roles and Stripe wired correctly, with webhooks you can trust.`)
};

const ar_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول والأدوار وStripe مربوطة بشكل صحيح، مع ويب هوك موثوقة.`)
};

const bn_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লগইন, রোল আর Stripe ঠিকমতো সংযুক্ত, বিশ্বস্ত webhook সহ।`)
};

const de_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login, Rollen und Stripe korrekt verdrahtet, mit Webhooks, denen Sie vertrauen können.`)
};

const es_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio de sesión, roles y Stripe bien conectados, con webhooks de confianza.`)
};

const fr_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion, rôles et Stripe correctement câblés, avec des webhooks de confiance.`)
};

const pt_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login, roles e Stripe bem ligados, com webhooks de confiança.`)
};

const zh_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录、角色和 Stripe 正确接线，webhook 值得信赖。`)
};

const tr_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş, roller ve Stripe doğru bağlanır, güvenilir webhookler ile.`)
};

const ru_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логин, роли и Stripe подключены правильно, с вебхуками, которым можно доверять.`)
};

const pl_svc_ai_app_rescue_auth_desc4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie, role i Stripe spięte poprawnie, z webhookami godnymi zaufania.`)
};

/**
* | output |
* | --- |
* | "Login, roles and Stripe wired correctly, with webhooks you can trust." |
*
* @param {Svc_Ai_App_Rescue_Auth_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_auth_desc4 = /** @type {((inputs?: Svc_Ai_App_Rescue_Auth_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Auth_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_auth_desc4(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_auth_desc4(inputs)
	return en_svc_ai_app_rescue_auth_desc4(inputs)
});
export { svc_ai_app_rescue_auth_desc4 as "svc_ai-app-rescue_AUTH_desc" }